<template>
  <el-card v-show="visible">
    <div class="row">
      <AuditPendenciesValueMoreCard ref="serviceValue" title="Por Serviço" v-on:reload="$emit('reload')" />
      <AuditPendenciesValueMoreCard ref="cardpostValue" title="Por Cartão Postagem" v-on:reload="$emit('reload')" />
      <AuditPendenciesValueMoreCard ref="customerValue" title="Por Cliente" v-on:reload="$emit('reload')" />
    </div>
  </el-card>
</template>
<script>
import { AuditService } from "@/services/customers/audit.services";
import AuditPendenciesValueMoreCard from './AuditPendenciesValueMoreCard';

export default {
  name: "AuditPendenciesValueMore",
  props: ["type"],
  components: {
    AuditPendenciesValueMoreCard,
  },
  data() {
    return {
      visible: false,
      tableData: [],
      loading: {
        cardpost: true,
      }
    }
  },
  methods: {
    show() {
      this.visible = true;
      this.fetch('serviceValue', 'services');
      this.fetch('cardpostValue', 'cardpost');
      this.fetch('customerValue', 'customers');
    },
    hide() {
      this.visible = false;
    },
    apply(index) {
      const vm = this;
      const record = vm.tableData[index];
      if (record.selected === '3' && !record.another) {
        return vm.$message({ type: "error", message: 'É preciso informar o cartão de postagem!' });
      }
      const loading = vm.$loading(vm.$options.loading);
      AuditService.change(record.selected, record.another, record.cardpost.audit, record.cardpost.prepost)
        .then((response) => {
          vm.$message({ type: "success", message: 'Cartão de postagem setado nas pendências de auditoria!' });
          vm.$emit('reload');
          vm.visible = false;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    fetch(ref, method) {
      const vm = this;
      setTimeout(() => {
        vm.$refs[ref].show(method, vm.type);
      }, 200);
    },
  },
};
</script>
<style scoped>
.list-group-item {
  padding-top: 15px !important;
}
</style>